import Map from './containers/MapContainer';
import Info from './containers/Info';
import Search from './containers/Search';
import AutoComplete from './containers/AutoComplete';
import LocationClose from './utils/location-close'

module.exports = {
  Map,
  Info,
  Search,
	AutoComplete,
	LocationClose
};
